module.exports = {
      id: "simple-arrow-usage",
      viewBox: "0 0 16 17",
      url: __webpack_public_path__ + "svg-sprite-3f41b5422aa8d7a50bd372d0b736cd55.svg#simple-arrow",
      toString: function () {
        return this.url;
      }
    }